import { Component } from 'react';
import PropTypes from 'prop-types';

import { omit } from 'lodash';
import displayName from 'component-lib/displayName';

import { availableContextTypes } from './TableView';

export default class TablePositionBase extends Component {
    static displayName = displayName('TableView/TablePositionBase');

    static propTypes = {
        position: PropTypes.string.isRequired,
    };

    static contextTypes = availableContextTypes;

    static childContextTypes = {
        position: PropTypes.string,
    };

    getChildContext() {
        return { position: this.props.position };
    }

    render() {
        const componentProps = omit(this.props, [
            'styleName',
            'styles',
            'componentClass',
            'position',
            'columnSelector',
        ]);

        return this.renderBody(componentProps);
    }
}
